import PropTypes from 'prop-types'
import { Button, ListGroup, ListGroupItem } from 'reactstrap'
import AddressView from 'domains/user/molecules/address-view'
import { useHistory } from 'react-router-dom'

const propTypes = {
  user: PropTypes.object
}

const UserDetailAddressPage = ({ user }) => {
  const history = useHistory()

  const handleClickEditAddress = (address) => {
    history.push({
      pathname : `/app/user-address/${address.id}/edit`,
      state    : { address: address }
    })
  }

  const handleClickNewAddress = () => {
    history.push({ pathname: `/app/users/${user.id}/addresses/create` })
  }

  return (
    <>
      <div className='text-right mb-3'>
        <Button
          outline
          color='primary'
          onClick={ () => handleClickNewAddress() }
        >
          <span>New Address</span>
          <i className="fas fa-plus ml-3" />
        </Button>
      </div>
      <ListGroup>
        {
          user?.addresses && user.addresses.map((address) => (
            <ListGroupItem key={ `address-list-item-${address.id}` }>
              <AddressView
                address={ address }
                handleClickEdit={ handleClickEditAddress }
              />
            </ListGroupItem>
          ))
        }
      </ListGroup>
    </>
  )
}

UserDetailAddressPage.propTypes = propTypes

export default UserDetailAddressPage
